<div class="white-bg">
    <breadcrumbs [noDivider]="true">
        <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
        <breadcrumb [currentRoute]="true" [label]="'Your Preferences'| translate | async"></breadcrumb>
    </breadcrumbs>
    
</div>
<div class="tabs tabs--max-width">
    <nav mat-tab-nav-bar>
        <a mat-tab-link
           routerLink="general"
           [active]="_router.url.includes('general')">
            {{'General' | translate | async}}
        </a>
        <a mat-tab-link
           routerLink="account"
           [active]="_router.url.includes('account')">
            {{'Account' | translate | async}}
        </a>
        <a mat-tab-link *ngIf="ShowAlertFiled"
           routerLink="alerts"
           [active]="_router.url.includes('alerts')">
            {{'Alerts' | translate | async}}
        </a>
         <a mat-tab-link *ngIf="ShowAlertFiled"
           routerLink="report"
           [active]="_router.url.includes('report')">
            {{'Report' | translate | async}}
        </a>
    </nav>
</div>
<div class="router-container">
    <router-outlet></router-outlet>
</div>
